export default __webpack_public_path__ + "static/saudi-5092840c90154a579d28fea222248936.png";